import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import Login from './routes/Login';
import BasicLayout from './layouts/BasicLayout';
import './App.less';

class App extends Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <Switch>
          <Route path="/login" component={Login} />
          <AuthRoute path="/" component={BasicLayout} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js